module.exports = __webpack_public_path__ + "img/2-icono-mistramites.d90d3f58.svg";